window.axios = require('axios');
import Vue from 'vue';
import '@morioh/v-lightbox/dist/lightbox.css';
import VueLazyImageLoading from 'vue-lazy-image-loading'

import Media from "./components/Media.vue";

Vue.config.productionTip = false;


// global register

Vue.use(VueLazyImageLoading);

new Vue({
    components: {
        Media
    },
}).$mount('#app');
